import React from "react";
import styled from "@emotion/styled";
import withTranslator from "../Translator/withTranslation";

const TextContainer = styled.div`
    @media (max-width:768px){
        display:none;
    }
`;

class ChatWithUsComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    
    click(){
        loadZopim();
    }
    
    render() {
        const src = '/assets/img/front/icons/chat-'+this.props.iconColor+'.svg',
              label = this.props.label ? this.props.label : 'livechat_offline';
        const { t } = this.props;

        return (
            <div className={this.props.className}>
                <a href="#" onClick={this.click} className="flex blue1 font-120 font-w600">
                    <img alt="chat" className="mr-2" src={(this.props.searchURLBase ? this.props.searchURLBase : '') + src} height={this.props.height} width={this.props.width}/>
                    <TextContainer className="nowrap">{t(label)}</TextContainer>
                </a>
            </div>
        );
    }
}

export const ChatWithUs = withTranslator(ChatWithUsComponent);